import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import OrderStatusUpdate from '@/plugins/graphql/mutations/v2/order-status-update.gql';
import EcommerceOrder from '@/plugins/graphql/queries/v2/order.gql';
import OrderStatusActionMixin from '@/helpers/vue_mixins/v2/ecommerce/OrderStatusActionMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { Mutation } from 'vuex-class';
import { ORDER } from '@/helpers/constants/Store';
import OrderStatusBulkUpdate from '@/plugins/graphql/mutations/v2/order-status-bulk-update.gql';
import { OrderStatuses } from '@/helpers/entities/enums/v2/OrderStatuses';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
const namespace = { namespace: ORDER };
let OrderCompletedForm = class OrderCompletedForm extends mixins(OrderStatusActionMixin, ViewportSizeMixin, CleverTapEventsMixin) {
    async uponConfirm() {
        this.requestStart();
        await this.complete()
            .then(() => {
            /**
             * Trigger Mutation for Hiding Order Details Dialog
             * Unfortunately `emitter` doesn't work since this component is already
             * destroyed upon sending mutation
             * @author Jimson Lomio <jimson@gorated.ph>
             * @since Version {0.17.0}
             */
            if (this.xsOnly) {
                this.hideOrderDetails();
            }
            this.successNotification('Successfully Mark As Completed!');
            this.orderAction('MARK AS COMPLETED ORDER');
            this.$router.push({
                name: 'ecommerce-orders-by-status',
                params: { status: 'completed' },
            });
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async complete() {
        if (this.orderStatusUuids.length >= 2) {
            return this.$apollo.mutate({
                mutation: OrderStatusBulkUpdate,
                variables: {
                    input: {
                        orderStatuses: this.orderStatusUuids,
                        status: 'completed',
                    },
                },
            });
        }
        const appUuid = this.appUUID;
        const currentStatus = OrderStatuses.completed;
        const prevStatus = OrderStatuses.forDelivery;
        const vm = this;
        return this.$apollo.mutate({
            mutation: OrderStatusUpdate,
            variables: {
                input: {
                    orderStatusUuid: this.orderStatusUuid,
                    status: currentStatus,
                },
            },
            update(cache, { data }) {
                const updatedOrderStatus = data.orderStatusUpdate.orderStatus;
                vm.updateOrderStatusCache(prevStatus, currentStatus, updatedOrderStatus, vm.orderUuid, appUuid, cache);
            },
            refetchQueries: [
                {
                    query: EcommerceOrder,
                    variables: {
                        orderUuid: vm.orderUuid,
                    },
                },
            ],
        });
    }
};
__decorate([
    Prop({ type: Array, default: () => [] })
], OrderCompletedForm.prototype, "orderStatusUuids", void 0);
__decorate([
    Mutation('hideOrderDetails', namespace)
], OrderCompletedForm.prototype, "hideOrderDetails", void 0);
OrderCompletedForm = __decorate([
    Component({
        components: {
            ActionButton,
        },
    })
], OrderCompletedForm);
export default OrderCompletedForm;
